import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import React, {useEffect} from "react";
import {BrowserRouter, NavLink, Route, Routes} from "react-router-dom";
import {About} from "./about/about";
import {Generate} from "./generate/generate";
import {Explore} from "./explore/explore";
import {Login} from "./login/login";
import {Authenticated} from "./login/authenticated";
import {AuthState} from "./login/authState";
import Button from "react-bootstrap/Button";

function Home({userName, authState, onAuthChange}) {
    // Check if user is logged in (either by localStorage or authState)
    const isLoggedIn = localStorage.getItem("userName") != null || authState === AuthState.Authenticated;
    
    console.log('Home component - userName:', userName, 'authState:', authState, 'isLoggedIn:', isLoggedIn);
    
    if (!isLoggedIn) {
        return <Login userName={userName} authState={authState} onAuthChange={onAuthChange}/>;
    }

    // Show the authenticated file upload interface when user is logged in
    return (
        <Authenticated 
            userName={userName}
            onlogout={() => onAuthChange("", AuthState.Unauthenticated)}
        />
    );
}

function logout() {
    fetch(`/api/auth/logout`, {
        method: 'delete',
    }).then(() => {
        localStorage.removeItem('userName');
        window.location.href = '';
    });
}

function App() {
    const [userName, setUserName] = React.useState(localStorage.getItem("userName") || "");
    const [authState, setAuthState] = React.useState(AuthState.Unknown);
    const [theme, setTheme] = React.useState(() => localStorage.getItem('theme') || 'light');

    const toggleTheme = () => {
        const next = theme === 'light' ? 'dark' : 'light';
        setTheme(next);
        localStorage.setItem('theme', next);
    };

    useEffect(() => {
        document.documentElement.setAttribute('data-theme', theme);
    }, [theme]);

    useEffect(() => {
        if (userName) {
            fetch(`/api/user/${userName}`)
                .then((res) => {
                    if (res.status === 200) {
                        return res.json();
                    }
                    throw new Error(`HTTP ${res.status}`);
                })
                .then((user) => {
                    const state = user?.authenticated ? AuthState.Authenticated : AuthState.Unauthenticated;
                    setAuthState(state);
                })
                .catch((error) => {
                    console.error('Error checking user authentication:', error);
                    // If we can't verify authentication, assume user is authenticated if they have a userName
                    setAuthState(AuthState.Authenticated);
                });
        } else {
            setAuthState(AuthState.Unauthenticated);
        }
    }, [userName]);
    return (
        <BrowserRouter>
            <div className="app-container">
                {/* CRT scanline overlay */}
                <div className="crt-overlay" aria-hidden="true" />

                <header className="app-header">
                    <nav className="navbar navbar-expand-lg">
                        <div className="navbar-brand">
                            <NavLink className="brand-link" to="/">
                                <span className="brand-text">&gt; LIGHTNING.IO</span>
                                <span className="brand-cursor">_</span>
                            </NavLink>
                        </div>

                        <button
                            className="navbar-toggler"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#navbarNav"
                            aria-controls="navbarNav"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                        >
                            <span className="navbar-toggler-icon"></span>
                        </button>

                        <div className="collapse navbar-collapse" id="navbarNav">
                            <ul className="navbar-nav me-auto">
                                <li className="nav-item">
                                    <NavLink className="nav-link" to='/'>
                                        {authState === AuthState.Authenticated ? '~/home' : '~/login'}
                                    </NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink className="nav-link" to='/about'>./about</NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink className="nav-link" to='/explore'>./explore</NavLink>
                                </li>
                            </ul>

                            <div className="navbar-right">
                                <button className="theme-toggle" onClick={toggleTheme} title={theme === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}>
                                    {theme === 'light' ? '☾' : '☀'}
                                </button>
                                {authState === AuthState.Authenticated && (
                                    <div className="navbar-nav user-section">
                                        <span className="user-info">{userName}@lightning</span>
                                        <Button
                                            variant="outline-primary"
                                            className="logout-btn"
                                            onClick={logout}
                                        >
                                            [ LOGOUT ]
                                        </Button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </nav>
                </header>

                <main className="app-main">
                    <Routes>
                        <Route path='/' element={
                            <Home userName={userName}
                                   authState={authState}
                                   onAuthChange={(userName, authState) => {
                                       setUserName(userName);
                                       setAuthState(authState);
                                   }}
                            />
                        } exact />
                        <Route path='/about' element={<About/>}/>
                        <Route path='/explore' element={<Explore/>}/>
                        <Route path='/generate' element={
                            authState === AuthState.Authenticated ? 
                            <Generate/> : 
                            <Login userName={userName} authState={authState} onAuthChange={(userName, authState) => {
                                setUserName(userName);
                                setAuthState(authState);
                            }}/>
                        }/>
                        <Route path='*' element={<NotFound/>}/>
                    </Routes>
                </main>

                <footer className="app-footer">
                    <div className="footer-content">
                        <a className="footer-link footer-credit" href="http://chris-chau.com">// credit: chris chau</a>
                        <a className="footer-link" href="https://github.com/ChrisChauyh/startup">$ git clone</a>
                    </div>
                </footer>
            </div>
        </BrowserRouter>
    );
}

function NotFound() {
    return (
        <div className="not-found">
            <h1>404</h1>
            <p>[ERR] path not found</p>
            <p>the route you requested does not exist.</p>
        </div>
    );
}

export default App;
